module.exports = __webpack_public_path__ + "img/handshake.fdde424b.svg";